import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CyberSecurity from '../../../apis/cyberSecurityData';

//imported components
import ExistRelatedItem from './ExistRelatedItem';

const ListOfExistRelations = (props) => {
    //redux
    const accessToken = useSelector(state => state.accessToken)
    //creating a hook to include the items to be shown, and initialize it with the items from the redux store.
    const [currentBreaches, setCurrentBreaches] = useState([])
    const [currentStories, setCurrentStories] = useState([])
    const [currentThreats, setCurrentThreats] = useState([])
    const [currentActors, setCurrentActors] = useState([])
    const [currentSolutions, setCurrentSolutions] = useState([])
    const [currentCompanies, setCurrentCompanies] = useState([])
    const [currentExperts, setCurrentExperts] = useState([])

    const fetchData = async () => {
        const { item } = props;
        const response = await CyberSecurity.post('/fetchrelations', { ItemId: item._id }, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        });

        if (response.data[0] && response.data[0].relatedThreats.length > 0) {
            let relatedThreats = response.data[0].relatedThreats;
            if (response.data[0].ttpData && response.data[0].ttpData.length > 0) {
                relatedThreats = relatedThreats.map(el => { return { ...el, ttpData: response.data[0].ttpData.filter(ttp => ttp.threatId === el._id) } })
            }
            setCurrentThreats(relatedThreats);

        }

        setCurrentBreaches(response.data[0].relatedBreaches);
        setCurrentStories(response.data[0].relatedStories);
        setCurrentActors(response.data[0].relatedActors);
        setCurrentSolutions(response.data[0].relatedSolutions);
        setCurrentCompanies(response.data[0].relatedCompanies);
        setCurrentExperts(response.data[0].relatedExperts);
    }

    useEffect(() => {
        fetchData();
    }, [])

    const onDeleteClick = (item) => {
        if (item.mainCategory === 'Stories' && item.newTag5 && item.newTag5.toLowerCase().includes('breach')) {
            return setCurrentBreaches(currentBreaches.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Stories') {
            return setCurrentStories(currentStories.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Threats') {
            return setCurrentThreats(currentThreats.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Actors') {
            return setCurrentActors(currentActors.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Solutions') {
            return setCurrentSolutions(currentSolutions.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Companies') {
            return setCurrentCompanies(currentCompanies.filter(el => el._id !== item._id))
        }
        if (item.mainCategory === 'Experts') {
            return setCurrentExperts(currentExperts.filter(el => el._id !== item._id))
        }
    }

    const renderExistBreaches = () => {
        if (currentBreaches && currentBreaches.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Breaches">Related Breaches</p>
                    {currentBreaches.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }
    const renderExistStories = () => {
        if (currentStories && currentStories.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Stories">Related Stories</p>
                    {currentStories.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }
    const renderExistThreats = () => {
        if (currentThreats && currentThreats.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Threats">Related Threats</p>
                    {currentThreats.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} fetchData={fetchData} />)}
                </div>
            )
        }
    }
    const renderExistActors = () => {
        if (currentActors && currentActors.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Actors">Related Actors</p>
                    {currentActors.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }
    const renderExistSolutions = () => {
        if (currentSolutions && currentSolutions.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Solutions">Related Solutions</p>
                    {currentSolutions.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }
    const renderExistCompanies = () => {
        if (currentCompanies && currentCompanies.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Companies">Related Companies</p>
                    {currentCompanies.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }
    const renderExistExperts = () => {
        if (currentExperts && currentExperts.length > 0) {
            return (
                <div>
                    <p className="exist-relation-title info-Experts">Related Experts</p>
                    {currentExperts.map(el => <ExistRelatedItem mainItem={props.item} item={el} key={el._id} onDeleteClick={onDeleteClick} />)}
                </div>
            )
        }
    }

    return (

        <div className="current-relations">
            {renderExistBreaches()}
            {renderExistStories()}
            {renderExistThreats()}
            {renderExistActors()}
            {renderExistSolutions()}
            {renderExistCompanies()}
            {renderExistExperts()}
        </div>
    )
}

export default ListOfExistRelations
